import i18next from 'i18next';

/**
 * Registers English strings for the `connection` package namespace
 * and shared `ai-tool` chat-label notes for Composio-prefixed tools.
 * Chat title fallbacks for `connection__*` keys reuse `_mcp*` via `translateAiTool`.
 */
export default function initI18n(): void {
  i18next.addResourceBundle('en', 'connection', {
    connectionStatusInitializing: 'Initializing',
    connectionStatusInitiated: 'Waiting for authorization',
    connectionStatusActive: 'Connected',
    connectionStatusFailed: 'Failed',
    connectionStatusExpired: 'Expired',
    connectionStatusInactive: 'Disabled',
    connectionStatusRevoked: 'Revoked',
    serviceIdentity: 'Uvilo ops',
    toolkitGithub: 'GitHub',
    toolkitVercel: 'Vercel',
    toolkitNeon: 'Neon',
  });

  i18next.addResourceBundle('en', 'ai-tool', {
    connectToolkit: 'Connect toolkit',
    connectToolkitReasoning: 'Asking to connect `{{toolCall.input.toolkitSlug}}`',
    connectToolkitOutput: 'Toolkit connection answered',
    connectToolkitError: 'Error connecting toolkit',
    searchToolkits: 'Search toolkits',
    searchToolkitsReasoning: 'Searching Composio toolkits',
    searchToolkitsOutput: 'Found {{toolCall.output.count}} toolkit(s)',
    searchToolkitsNoop: 'No matching toolkits',
    searchToolkitsError: 'Error searching toolkits',
  });
}
